import {
    instance as axios,
    setJwtToken,
  } from "../../config/axiosInstance";
  
export const MotorSkillTrackingListApi = async (data) => {
  const endPoint = `admin/motor-skill-tracking/list?${new URLSearchParams(
    data
  ).toString()}`;
  return await axios.get(endPoint, setJwtToken());
};